import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { VehicleType } from '../models';

import { API_FLEET_URL } from '@/utils';

import { RootState } from '@/store/store';

const vehiclesTypesService = createApi({
  reducerPath: 'vehiclesTypesService',
  baseQuery: fetchBaseQuery({ baseUrl: `${API_FLEET_URL}/vehicle-types` ,
          prepareHeaders: (headers, { getState }) => {
            const state = getState() as RootState;
      
            const token = state.auth?.auth?.accessToken || null;
            if (token) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
          },}),
  endpoints: (builder) => ({
    getVehiclesTypes: builder.query<VehicleType[], void>({
      query: () => '',
      transformResponse: (response: { items: VehicleType[] }) => response.items,
    }),
  }),
});

export default vehiclesTypesService;

export const {
  useGetVehiclesTypesQuery,
} = vehiclesTypesService;
